import React, {useEffect, useState, useRef} from 'react';
import {InputText} from 'primereact/inputtext';
import {Password} from 'primereact/password';
import {Button} from 'primereact/button';
import * as auth from "../../actions/auth";
import connect from "react-redux/lib/connect/connect";
import {Redirect} from "react-router-dom";
import {Toast} from 'primereact/toast';


const Login = props => {

    const toast = useRef(null);
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [submitBtnDisable, setSubmitBtnDisable] = useState(false);

    const showError = (message) => {
        // this.setState({disable_submit_btn: false})
        toast.current.show({severity: 'error', summary: message, detail: '', life: 3000});

    }

    const onSubmit = e => {
        e.preventDefault();
        props.login(userName, password);
    }


    useEffect(() => {

        if (props.errors) {
            if (props.errors.length > 0) {
                if (props.errors[0].message === 'LOGIN_FAILED') {
                    showError(props.errors[1].message);
                    //this.setState({disable_submit_btn: false})
                }
            }
        }
    }, [props]);

    if (props.isAuthenticated) {
        return <Redirect to="#/main"/>
    }
    return (
        <div className="login-body">
            <Toast ref={toast}/>
            <div className="login-wrapper">
                <div className="login-panel">
                    {/*<img src="assets/layout/images/logo-dark.svg" className="logo" alt="diamond-layout"/>*/}
                    {/*<form onSubmit={event => onSubmit(event)}>*/}
                    <div className="login-form" style={{marginTop: '40%'}}>
                        <h2>Yapay Zeka Platform Giriş Sayfası</h2>
                        <strong>Portale Yanlızca E-devlet ile Giriş Yapılabilir.</strong>

                        <div className="p-col-12 p-md-12 p-lg-12" align="center">
                            <a href="https://giris.turkiye.gov.tr/OAuth2AuthorizationServer/AuthorizationController?response_type=code&client_id=361225ca-520c-4408-9b79-1524d389bcd0&state=random_value&scope=Kimlik-Dogrula;Ad-Soyad;Temel-Bilgileri;Iletisim-Bilgileri&redirect_uri=https://ssyz.org.tr/edevlet/login?redirect=platform"
                               style={{zIndex: '9000'}}>
                                <img src="/static/assets/layout/images/edevlet/e-devlet-giris-logo.png" alt=""/>
                            </a>
                        </div>

                        {/*<InputText value={userName}*/}
                        {/*           onChange={e => setUserName(e.target.value)}*/}
                        {/*           id="user_username" name="user_username" maxLength={32} autoFocus/>*/}
                        {/*<Password value={password}*/}
                        {/*          id="user_password"*/}
                        {/*          name="user_password"*/}
                        {/*          feedback={false}*/}
                        {/*          onChange={e => setPassword(e.target.value)}/>*/}
                        {/*<Button*/}
                        {/*    label="Giriş Yap"*/}
                        {/*    className="p-button-primary p-button-rounded p-button-seen p-button-wid"*/}
                        {/*    type="submit"/>*/}

                    </div>
                    {/*</form>*/}

                    {/*<p>A problem? <a href="/">Click here</a> and let us help you.</p>*/}
                </div>
                <div className="login-image">
                    <div className="login-image-content">
                        <h1>Yapay Zeka Platformu</h1>
                        {/*<h1>Diamond</h1>*/}
                        {/*<h1>Account</h1>*/}
                        {/*<h3>*/}
                        {/*    Lorem ipsum dolor sit amet, consectetur <br/>*/}
                        {/*    adipiscing elit. Donec posuere velit nec enim <br/>*/}
                        {/*    sodales, nec placerat erat tincidunt.*/}
                        {/*</h3>*/}
                    </div>
                    {/*<div className="image-footer">*/}
                    {/*    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>*/}
                    {/*    <div className="icons">*/}
                    {/*        <i className="pi pi-github"></i>*/}
                    {/*        <i className="pi pi-twitter"></i>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = state => {
    let errors = [];
    if (state.auth.errors) {
        errors = Object.keys(state.auth.errors).map(field => {
            return {field, message: state.auth.errors[field]};
        });
    }
    return {
        errors,
        isLoggedIn: state.loggedIn,
        isAuthenticated: state.auth.isAuthenticated
    };
}

const mapDispatchToProps = dispatch => {
    return {
        login: (user_username, user_password) => {
            return dispatch(auth.login(user_username, user_password));
        }
    };
}


export default connect(mapStateToProps, mapDispatchToProps)(Login);


// WEBPACK FOOTER //
// ./src/pages/authentication/Login.jsx